import { dispatch } from 'lib/store'
import {
  SET_SELECTED_ATTRIBUTE,
  TRIGGER_MANUAL_SEARCH,
} from 'constants/action-types'

import log from 'lib/log'

/**
 * Set selected attribute code (when user clicks on tree node)
 */
export const setSelectedAttribute = (attributeCode: string | null): void => {
  dispatch(SET_SELECTED_ATTRIBUTE, attributeCode)
  if (attributeCode) {
    log.debug('Attribute selected', { attributeCode })
  }
}

/**
 * Trigger search - manual (user clicked Search) or initial (demo mode)
 * Sets timestamp to trigger fetch operations
 */
export const triggerSearch = (manual: boolean): void => {
  const timestamp = new Date().toISOString()
  log.debug(manual ? 'Manual search' : 'Initial search')
  dispatch(TRIGGER_MANUAL_SEARCH, timestamp)
}
